module.exports = __webpack_public_path__ + "assets/img/21_765.18671af4.jpg";